var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrganismMap',{attrs:{"clubs":_vm.clubs}})
}
var staticRenderFns = []

export { render, staticRenderFns }